module.exports = __webpack_public_path__ + "pc/img/swiper_logo_07.78d8579b.png";